<script setup lang="ts">
import type { FormItem } from '@/entries/interact-form/types'
import { ANSWER_PREFIX_PATTERN } from '@/entries/interact-form/constants'

const props = defineProps<{
  question: FormItem
}>()

const emit = defineEmits<{
  'update:answer': [value: string]
}>()

/**
 * セレクトボタンの回答を設定
 *
 * ユーザーがボタンをクリックしたときに呼び出され、
 * 選択された値を親コンポーネントに通知します
 *
 * @param {string} value - 選択されたボタンの値
 */
function setSelectAnswer(value: string) {
  emit('update:answer', value)
}
</script>

<template>
  <div class="option-group select-group">
    <button v-for="(option, index) in question.data" :key="index" class="select-button"
      :class="{ selected: question.answer === option }" @click="setSelectAnswer(option)">
      {{ question.is_trigger ? option.replace(ANSWER_PREFIX_PATTERN, '') : option }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.select-group {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 28px;
  justify-content: center;
}

.select-button {
  text-align: center;
  padding: 48px;
  padding-left: 64px;
  background-color: #36b4a8;
  border: 4px solid #36b4a8;
  border-radius: 20px;
  color: white;
  position: relative;
  font-size: 32px;
  font-weight: bold;
  &::after {
    content: '▲';
    display: block;
    position: absolute;
    top: 50%;
    left: 32px;
    transform: translate(-50%, -50%) rotate(90deg);
    font-size: 32px;
    font-weight: bold;
  }
}

.select-button:hover {
  border: 4px solid #a5dbdf;
  cursor: pointer;
  color: #36b4a8;
  background-color: #fff;
}

.select-button.selected {
  border: 4px solid #a5dbdf;
  cursor: pointer;
  color: #36b4a8;
  background-color: #fff;
}

// スマホ向けのスタイル
@media screen and (max-width: 767px) {
  .select-group {
    gap: 15px; // ボタン間の間隔を縮小
    margin: 0 auto; // 中央揃え
  }

  .select-button {
    padding: 15px 15px 15px 35px; // パディングを縮小
    border-width: 2px; // ボーダーを細く
    border-radius: 12px; // 角丸を小さく
    font-size: 16px; // フォントサイズを小さく
    width: 100%; // 幅を100%に設定して縦に並べる
    max-width: 280px; // 最大幅を設定

    &::after {
      left: 18px; // 矢印の位置を調整
      font-size: 16px; // 矢印のサイズを小さく
    }
  }

  // 選択状態のボタンスタイル調整
  .select-button.selected {
    border-width: 2px;
  }
}
</style>
